/**
 * Where a signed-in user without an organization starts onboarding.
 *
 * Creators who arrive from a campaign invite or the link-in-bio flow keep the
 * creator path (persona → shipping details → offer). Everyone else gets the
 * one-screen property setup: website, channels, analytics, then the product.
 */
export const isCreatorEntry = (): boolean => {
  if (typeof localStorage !== 'object') return false;
  return (
    localStorage.getItem('role') === 'creator' ||
    !!localStorage.getItem('setupAuthTaskSecret') ||
    !!localStorage.getItem('onboardingPath')
  );
};

export const onboardingEntry = (): string =>
  isCreatorEntry() ? '/onboarding/persona' : '/onboarding/start';

/** "myhealthydish.com" → "Myhealthydish"; used to prefill the property name. */
export const nameFromWebsite = (website: string): string => {
  try {
    const host = new URL(
      /^https?:\/\//i.test(website) ? website : `https://${website}`,
    ).hostname.replace(/^www\./, '');
    const label = host.split('.')[0] || '';
    return label ? label.charAt(0).toUpperCase() + label.slice(1) : '';
  } catch {
    return '';
  }
};

export const normalizeUrl = (value: string): string => {
  const v = value.trim();
  if (!v) return '';
  return /^https?:\/\//i.test(v) ? v : `https://${v}`;
};
